import styled from "styled-components";
import Icon from "../../../atoms/icon/icon.component.js";
export const IconContainer = styled(Icon).withConfig({
  displayName: "table-headstyles__IconContainer",
  componentId: "sc-4l0z0d-0"
})(["", ""], {
  marginLeft: "0.5rem"
});
